import { render } from "./DigitCodeInput.vue?vue&type=template&id=4860bfdc&scoped=true"
import script from "./DigitCodeInput.vue?vue&type=script&lang=js"
export * from "./DigitCodeInput.vue?vue&type=script&lang=js"

import "./DigitCodeInput.vue?vue&type=style&index=0&id=4860bfdc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4860bfdc"]])

export default __exports__